module.exports = __webpack_public_path__ + "img/empty-state.ac3be45c.png";